export const ROUTES_PATHS = {

  PriorAuth: {
    Summary: '/prior-auth',
    GoldCard: '/prior-auth/gold-card',
    PACptCodes: '/prior-auth/pa-cpt-codes',
    PANotApproved: '/prior-auth/pa-not-approved',
  },
  PatientCROpportunity: '/patient-care-opportunity',
  MyInsights: '/myinsights',
  MyHome: '/myhome',
  Operations: '/operations',
  Reimbursements: {
    Processed: '/reimbursements',
    Payments: '/reimbursements/payments',
    NonPayments: '/reimbursements/non-payments',
    Reconsiderations: '/reimbursements/reconsiderations',
    OverPayments: '/reimbursements/overpayments',
    Appeals: '/reimbursements/appeals',
    PaymentIntegrity: '/reimbursements/payment-integrity-page',
  },
  Overview: {
    OverviewAdvocate: '/overview-page-advocate',
    HealthSystem: '/overview-page-advocate/health-system-details',
  },
  ContractIdDetails: '/contract-id-details',
  Ancillary: {
    Root: '/ancillary',
    Labs: '/ancillary/labs',
    Imaging: '/ancillary/imaging'
  },

  NetworkManagement: {
    ExemptSummary: '/network-management/exemption-summary',
    AffSummary: '/network-management/affordability-summary',
    ADMReport: '/network-management/adm-report',
    VBC: '/network-management/vbc',
    AffSOS: '/network-management/affordability-sos-details',
    AffSOSOffice: '/network-management/affordability-sos-details/office',
    AffSOSColonoscopy: '/network-management/affordability-sos-details/colonoscopy',
    AffSOSSurgery: '/network-management/affordability-sos-details/surgery',
    AffDDPImage: '/network-management/ddp-image',
    AffDDPLab: '/network-management/ddp-lab',
    AffMedSourcing: '/network-management/affordability-med-sourcing',
    AffDetails: '/network-management/affordability-details',
    AffRADCardPA: '/network-management/affordability-rad-card-pa',
    AffEDCAnalyzer: '/network-management/affordability-edc-analyzer',
    DrugManagement: '/network-management/drug-management',
    DrugManagementRareComplex: '/network-management/drug-management/rare-complex',
    ContractRemidiation: '/network-management/contract-renewal-remediation',
    Redirections: '/network-management/redirections'
  },
  PSMS: {
    Summary: '/PSMS',
    Claims: '/PSMS/Claims',
    PriorAuthorization: '/PSMS/PriorAuthorization',
    PaymentIntegrity: '/PSMS/PaymentIntegrity',
    AccountsReceivable: '/PSMS/AccountReceivable',
    ChatAndCalls: '/PSMS/CallsAndChat',
    PRC: '/PSMS/PRC',
    ViewTaxIdDetails: '/PSMS/ViewTaxIdDetails'

  } ,
  ContractIntelligence: {
    Scorecard: '/scorecard',
    HeatMap: '/scorecard/heatmap'
  },
  AffDriver: {
    MedicalCost: '/medical-cost'
  },
  Providers: {
    Briefing: '/provider-briefing',
    BriefingDoc: '/provider-briefing/document',
    Experience: '/provider-experience',
    PEM: {
    Summary: '/pem-summary',
    PEMDetails: '/pem-details',
  },
},
  ContentEditor: {
    root: '/content-editor',
    FAQ: '/content-editor/faq-documentation',
    Onboarding: '/content-editor/onboarding-content-editor',
    Notification: '/content-editor/notification-banner-manager'
  }
}





